var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckOn = function SvgCheckOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#3C3C3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.943 17.143-4.61-4.74 1.224-1.223 3.386 3.463 7.5-7.786 1.224 1.172-8.724 9.114Z",
    fill: "#fff"
  })));
};
export { SvgCheckOn as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjIiIHk9IjIiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjMiIGZpbGw9IiMzQzNDM0IiLz4KPHBhdGggZD0iTTkuOTQyNzEgMTcuMTQzMkw1LjMzMzMzIDEyLjQwMzZMNi41NTcyOSAxMS4xNzk3TDkuOTQyNzEgMTQuNjQzMkwxNy40NDI3IDYuODU2NzVMMTguNjY2NyA4LjAyODYzTDkuOTQyNzEgMTcuMTQzMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";